import { IAdditionalNavItem } from "./IAdditionalNavItem";

export const AdditionalNavItem: IAdditionalNavItem[] = []